import { useState } from 'react';
import { FlexContainer, Text } from '@taxdown/piccolo-web';
import useTranslation from 'Hooks/useTranslation';
import { AlertIcon } from 'Components/icons';
import Arrow from 'Components/icons/Arrow';
import { InvalidBoxProps, defaultProps } from './types';
import * as Styled from './styles';

const InvalidBox = ({ className, errors }: InvalidBoxProps): JSX.Element => {
  const [isActive, setIsActive] = useState(false);
  const { t } = useTranslation();

  const handleOnClick = (e: Event): void => {
    e.preventDefault();
    e.stopPropagation();
    setIsActive(!isActive);
  };

  return (
    <Styled.InvalidBox className={className} onClick={handleOnClick}>
      <FlexContainer justify="space-between">
        <FlexContainer align="center">
          <AlertIcon />
          <Text type="paragraphs" color="dark" size="S_M_M" ml="dimension_10">
            {t('SummaryCard.emptyData')}
          </Text>
        </FlexContainer>
        <Styled.Button isActive={isActive}>
          <Arrow />
        </Styled.Button>
      </FlexContainer>
      {errors && errors.length > 0 && isActive && (
        <Styled.ErrorsList>
          {errors.length > 5 ? (
            <li>{t('SummaryCard.limit')}</li>
          ) : (
            errors.map(({ id, label }) => label && <li key={id}>{label}</li>)
          )}
        </Styled.ErrorsList>
      )}
    </Styled.InvalidBox>
  );
};

InvalidBox.defaultProps = defaultProps;

export default InvalidBox;
